import { useState } from 'react';

export interface ApiError {
  validationErrors?: Record<string, string[] | string>;
  message?: string | string[];
  error?: boolean;
}

export const useFormErrors = () => {
  const [errors, _setErrors] = useState<Record<string, string[]>>({});

  const handleApiError = (apiResponse: unknown) => {
    if (typeof apiResponse === 'object' && apiResponse !== null && 'data' in apiResponse) {
      const data = apiResponse.data as ApiError;
      setErrors(data.validationErrors ?? data.message ?? 'Something went wrong!');
    } else {
      setErrors('Unhandled Error!');
    }
  };

  const setErrors = (newErrors: string | string[] | Record<string, string[] | string>) =>
    _setErrors(() => {
      if (typeof newErrors === 'string') {
        return {
          '': [newErrors],
        };
      } else if (Array.isArray(newErrors)) {
        return {
          '': newErrors,
        };
      } else {
        return Object.fromEntries(Object.entries(newErrors).map((err) => [err[0], Array.isArray(err[1]) ? err[1] : [err[1]]]));
      }
    });

  const clearErrors = () => _setErrors({});

  const hasError = Object.keys(errors).length > 0;

  return [
    errors,
    {
      setErrors,
      clearErrors,
      hasError,
      handleApiError,
    },
  ] as const;
};
